import {scrollRefresh} from './parallax'
export default function faq(){
     
     const faqs = Array.from(document.querySelectorAll('.faq'));

     if(faq.length > 0) return false;

     function removeActive(ele){
          for (let i = 0; i < faqs.length; i++) {
               if(ele !== faqs[i] && faqs[i].classList.contains('active')){
                    faqs[i].classList.remove('active')
               }
               
          }
     }
     
     for (let i = 0; i < faqs.length; i++) {
          const faq = faqs[i];

          faq.addEventListener('click', function(e) {
               e.preventDefault();
               removeActive(faq)
               this.classList.toggle('active');
               scrollRefresh();
          })

     }




     

}

